<template>
  <div class="app-container" ref="body">
    <div class="app-body">
      <van-nav-bar
        title="签名"
        left-text="返回"
        left-arrow
        fixed
        class="fixedapp"
        @click-left="goBack()"
      />

      <div class="sign-finish">
        <div class="wrap1" v-show="showFull">
          <div class="sign-title">请在虚线区域内签字</div>
          <canvas class="canvas1" ref="canvas1" />
          <div class="actions">
              <button class="danger" @click="handleClear1">清除</button>
              <button class="warning" @click="handleUndo1">撤销</button>
              <button class="primary" @click="handleFull">横屏</button>
              <button class="success" @click="handlePreview1">保存</button>
          </div>
        </div>
        <div class="wrap2" v-show="!showFull">
          <div class="actionsWrap">
            <div class="actions">
              <button class="danger" @click="handleClear2" >清除2</button>
              <button class="warning" @click="handleUndo2" >撤销2</button>
              <button class="primary" @click="handleFull" >竖屏2</button>
              <button class="success" @click="handlePreview2" >保存2</button>
            </div>
          </div>
          <canvas class="canvas" ref="canvas2" />
        </div>
      </div>
      <!-- <div>
        <div>预览：</div>
        <img v-if="imgSrc" :src="imgSrc" style="width:100%" />
      </div> -->
    </div>
  </div>
</template>

<script>
import siteMixin from '@/utils/site-mixin';
import SmoothSignature from 'smooth-signature';
export default {
  name: 'ssign',
  mixins: [siteMixin],
  data() {
    return {
      showFull: true,
      imgSrc: '',
      // innerWidth: 720,
      // innerHeight: 300
    };
  },
  computed: {
    sw() {
      let ww = this.ww;
      if (!ww) {
        ww = window.innerWidth;
      }
      return ww > 750 ? 750 : ww;
    }
  },
  watch: {
    sw() {
      this.initSignature1();
      this.initSignture2();
    }
  },
  mounted() {
    this.initSignature1();
    this.initSignture2();
  },
  methods: {
    show(flag) {
      this.visible = flag ? true : false;
    },
    initSignature1() {
      const canvas = this.$refs['canvas1'];
      const options = {
        width: this.sw - 20 - 4,
        height: (this.sw - 20 - 4) * 0.418,
        minWidth: 3,
        maxWidth: 10,
        openSmooth:true,
        // color: '#1890ff',
        // bgColor: '#f6f6f6',
      };
      console.log(options)
      this.signature1 = new SmoothSignature(canvas, options);
    },
    initSignture2() {
      const canvas = this.$refs['canvas2'];
      const options = {
        width: window.innerWidth - 120,
        height: window.innerHeight - 80 - 30,
        minWidth: 3,
        maxWidth: 10,
        openSmooth:true,
        // color: '#1890ff',
        // bgColor: '#f6f6f6',
      };
      this.signature2 = new SmoothSignature(canvas, options);
    },
    handleClear1() {
      this.signature1.clear();
    },
    handleClear2() {
      this.signature2.clear();
    },
    handleUndo1() {
      this.signature1.undo();
    },
    handleUndo2() {
      this.signature2.undo();
    },
    handleFull() {
      this.showFull = !this.showFull;
    },
    handlePreview1() {
      const isEmpty = this.signature1.isEmpty();
      if (isEmpty) {
        alert('isEmpty');
        return;
      }
      const pngUrl = this.signature1.getPNG();
      this.imgSrc = pngUrl;
      
      console.log(pngUrl);
      // window.open(pngUrl);
    },
    handlePreview2() {
      const isEmpty = this.signature2.isEmpty();
      if (isEmpty) {
        alert('isEmpty');
        return;
      }
      const canvas = this.signature2.getRotateCanvas(-90);
      const pngUrl = canvas.toDataURL();
      this.imgSrc = pngUrl;

      console.log('pngUrl',pngUrl);
      // window.previewImage(pngUrl, 90);
    },
    
  },
};
</script>

<style lang="less" scoped>
.app-body {
  
}
.sign-finish {
  margin-top: 60px;
  width: 100%;
  // height: 100vh;
  button {
    height: 32px;
    padding: 0 8px;
    font-size: 12px;
    border-radius: 2px;
  }
  .danger {
    color: #fff;
    background: #ee0a24;
    border: 1px solid #ee0a24;
  }
  .warning {
    color: #fff;
    background: #ff976a;
    border: 1px solid #ff976a;
  }
  .primary {
    color: #fff;
    background: #1989fa;
    border: 1px solid #1989fa;
  }
  .success {
    color: #fff;
    background: #07c160;
    border: 1px solid #07c160;
  }
  canvas {
    border-radius: 10px;
    border: 2px dashed #ccc;
    
  }
  .wrap1 {
    margin: auto;
    width: calc(100% - 20px);
    .actions {
      display: flex;
      width: 100%;
      justify-content: space-around;
    }
  }
  .wrap2 {
    padding: 15px;
    height: 100%;
    display: flex;
    justify-content: center;
    .actionsWrap {
      width: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .canvas {
      flex: 1;
    }
    .actions {
      margin-right: 10px;
      white-space: nowrap;
      transform: rotate(90deg);
      button{
          margin-right: 20px;
      }
    }
  }
}
</style>